import { externalApi } from "./api";

class ServicioExterno {

    // private basicURL: string;

    // constructor() {
    //     this.basicURL = "/algo";
    // }

    async redirigirRecetaElectronica(jwt: string, matricula: string) {
        const endpoint = '/';
        const body = JSON.stringify({
            jwt: jwt,
            matricula: matricula,
        });
        try {
            const response = await externalApi.post(endpoint, body);
            return response.data;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);
                return "invalid";
            } else {
                console.error("Unknown error occurred");
                return "invalid";
            }
        }
    }
}

export default ServicioExterno;